export const Login = {
	title: "Log ind",
	description: "Log in for at se fremtidens hydrauliske platform.",
	button_text: "Log ind",
	button_text_loading: "Logger ind...",
	error_message: "Login mislykkedes. Prøv igen senere.",
	forgot_password_link_text: "Glemt adgangskode?",
	microsoft_sso_button_text: "Log ind med Microsoft",
};
